import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { createContext, useContext, useEffect } from "react";
import { useLocalObservable } from "mobx-react-lite";
import App from "next/app";
import { UAParser } from "ua-parser-js";
import { debounce } from "debounce";
const UserAgentModel = (props)=>{
    return {
        _ua: props.ua,
        get source () {
            var _this__ua;
            return (_this__ua = this._ua) === null || _this__ua === void 0 ? void 0 : _this__ua.source;
        },
        get userAgent () {
            return this._ua;
        },
        updateSource (uaString) {
            ;
            this._ua = parse(uaString);
        }
    };
};
const UserAgentStore = /*#__PURE__*/ createContext(null);
export const UserAgentProvider = (param)=>{
    let { initialValues , children  } = param;
    const store = useLocalObservable(()=>UserAgentModel(initialValues));
    return /*#__PURE__*/ _jsxs(UserAgentStore.Provider, {
        value: store,
        children: [
            " ",
            children
        ]
    });
};
export const useUserAgent = ()=>{
    const store = useContext(UserAgentStore);
    if (!store) {
        throw new Error("useStore must be used within a StoreProvider.");
    }
    useEffect(()=>{
        // window.addEventListener('orientationchange', function() {
        // 	// orientationChanged = true
        // 	console.log('orientationchange')
        // 	// setChangedView(true)
        // })
        const resize = debounce(()=>{
            ;
            store.updateSource(window.navigator.userAgent);
        }, 150);
        window.addEventListener("resize", resize);
        return ()=>{
            window.removeEventListener("resize", resize);
        };
    // @ts-ignore
    }, []);
    return store;
};
const getDisplayName = (Component)=>Component.displayName || Component.name || "Unknown";
// only use appcontenx
export function withUserAgent(WrappedComponent) {
    var _WithUserAgentComponent;
    return _WithUserAgentComponent = class WithUserAgentComponent extends App {
        render() {
            const props = {
                ...this.props
            };
            return /*#__PURE__*/ _jsx(WrappedComponent, {
                ...props
            });
        }
    }, (()=>{
        _WithUserAgentComponent.displayName = "WithUserAgent(".concat(getDisplayName(WrappedComponent), ")");
    })(), (()=>{
        _WithUserAgentComponent.getInitialProps = async (pageCtx)=>{
            const ctx = "Component" in pageCtx ? pageCtx.ctx : pageCtx;
            // const ctx = 'Component' in pageCtx ? pageCtx.ctx : pageCtx
            let uaString;
            if ("object" === "undefined") {
                var _ctx_req;
                // @ts-ignore
                uaString = (_ctx_req = ctx.req) === null || _ctx_req === void 0 ? void 0 : _ctx_req.headers["user-agent"];
            } else {
                uaString = window.navigator.userAgent;
            }
            const pageProps = await WrappedComponent.getInitialProps(pageCtx);
            if (uaString) {
                const ua = parse(uaString);
                // if (WrappedComponent as NextPage) {
                // const nextPage: NextPage = WrappedComponent as NextPage
                // if (nextPage && nextPage.getInitialProps) {
                // @ts-ignore
                ctx.ua = ua;
                return {
                    ...pageProps,
                    ua
                };
            } else {
                return {
                    ...pageProps
                };
            }
        };
    })(), _WithUserAgentComponent;
}
/**
 * Get the information of an useragent string.
 *
 * @param phase user agent strings.
 * @returns parsed information.
 */ export function parse(phase) {
    const result = new UAParser(phase).getResult();
    const regex = new RegExp("(".concat(BOT_UA.join("|"), ")"), "ig");
    const isBot = phase ? regex.test(phase.toLowerCase()) : false;
    const browser = result.browser.name;
    const deviceType = result.device.type;
    const os = result.os.name;
    const isMobile = deviceType === "mobile";
    const isTablet = deviceType === "tablet";
    const isIos = os === "iOS";
    const ua = Object.freeze({
        browser,
        deviceType,
        os,
        isMobile,
        isTablet,
        isIos,
        source: phase,
        deviceVendor: result.device.vendor,
        osVersion: parseInt(result.os.version, 10),
        browserVersion: parseFloat(result.browser.version),
        isIphone: isMobile && isIos,
        isIpad: isTablet && isIos,
        isDesktop: !isMobile && !isTablet,
        isChrome: browser === "Chrome",
        isFirefox: browser === "Firefox",
        isSafari: browser === "Safari",
        isIE: browser === "IE",
        isMac: os === "Mac OS",
        isChromeOS: os === "Chromium OS",
        isWindows: os === "Windows",
        isAndroid: os === "Android",
        isBot: isBot
    });
    return ua;
}
export const BOT_UA = [
    "\\+https:\\/\\/developers.google.com\\/\\+\\/web\\/snippet\\/",
    "googlebot",
    "baiduspider",
    "gurujibot",
    "yandexbot",
    "slurp",
    "msnbot",
    "bingbot",
    "facebookexternalhit",
    "linkedinbot",
    "twitterbot",
    "slackbot",
    "telegrambot",
    "applebot",
    "pingdom",
    "tumblr"
];
